import { render } from "./OtherRequestsAdmin.vue?vue&type=template&id=a61ef042"
import script from "./OtherRequestsAdmin.vue?vue&type=script&lang=js"
export * from "./OtherRequestsAdmin.vue?vue&type=script&lang=js"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__